// import { APP_CFG } from '../../../appcfg';
import { State } from '../../state';
import { saveUserState } from '../api';

export const saveProgress = (state: State): void => {
  const { userId } = state.ui;
  if (userId && state.currentProblemState.setup) {
    saveUserState(userId, state.progression, state.currentProblemState.setup);
  }
};
